<script lang="ts">
  // components
  import ResultsTable from './ResultsTable.svelte';

  // types
  import type { Readable } from 'svelte/store';
  import type { RaceInterface } from '../interfaces';

  /** @type {import('../types.d').ReadableRace} */
  export let race;

  /** @type {boolean} */
  export let face;

  /** @type {import('../types.d').Crosswalk} */
  export let crosswalk;



  // $: console.log($race);

  $: caption =
    $race.race_type === 'G' ? `` : $race.seat_name;
    
</script>

<ResultsTable
  {face}
  {crosswalk}
  {caption}
  raceId={$race.id}
  captionNote={$race.description}
  candidates={$race.candidates}
  totalVotes={$race.total_votes}
  office={$race.office}
  precinctsReportingPercent={$race.precincts_reporting_percent}
  eevp={$race.eevp} 
  numOfwinners={$race.number_of_winners}/>
